import { SpecificationTestOptions } from '@interfaces/specification-test-options';
import { getCall } from '@services/rest-service';

// Retrieves all the specification test options from cosmos
export const getSpecificationTestOptions = (): Promise<SpecificationTestOptions[]> => {
  return getCall<SpecificationTestOptions[]>('specification-test-options');
};